export default __webpack_public_path__ + "static/media/ContactAvatar.4c73ae1a.svg";